module.exports = __webpack_public_path__ + "img/indigo1.0b888de9.png";